<script lang="ts">
    import Snackbar, {Label} from '@smui/snackbar';
    import type { SnackbarComponentDev } from '@smui/snackbar';
    import {onMount} from "svelte";
    import {subscribeSnack} from "../api/snack";

    let snackbarOpen: SnackbarComponentDev;
    let label = 'Snackbar';

    const showSnack = (message: string) => {
        label = message;
        //@ts-ignore
        snackbarOpen.open();
    };

    onMount(() => {
        subscribeSnack(showSnack)
    })
</script>

<div>
    <Snackbar bind:this={snackbarOpen}>
        <Label>{label}</Label>
    </Snackbar>
</div>